module.exports = __webpack_public_path__ + "assets/Terrorism.81ee4c06.svg";